import { Props } from "./types";
import DropDownListWeb from "./web";

export function DropDownList(props: Props) {
	const defaultProps = {
		valueProp: "value",
		textProp: "label",
		loaded: true,
		highlightedValues: new Set<any>(),
	} as Props;
	// SS: 12/12/25 Disabling this as select if single does not work, and I don't believe that this is needed anymore.
	// Will Delete the mobile code in a few months if that remains true.
	// if (isMobile) return <DropDownListMobile {...defaultProps} {...props} />;
	return <DropDownListWeb {...defaultProps} {...props} />;
}

export * from "./async";
